// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"SelectorMenuToggleButton_buttonWrapper__EJZbm","templateSelect":"SelectorMenuToggleButton_templateSelect__EyF8S","icon":"SelectorMenuToggleButton_icon__tpTAU"};